export enum BatchState {
    Disabled,
    Active,
}
